import { ExtendedMunicipalityRecord } from "./municipalities";

export enum SearchType {
  Offices = "offices",
  Articles = "articles",
}

export enum FilterType {
  Search = "search",
  Location = "location",
  Dropdown = "dropdown",
}

export interface FilterValue {
  value: string | number;
  label: string;
}

export interface FilterMunicipalityValue {
  value: ExtendedMunicipalityRecord;
  label: string;
}

export interface FilterSettings {
  isClearable?: boolean;
  showCurrentLocation?: boolean;
}

export interface Filter {
  type: FilterType;
  label: string;
  key: string;
  options?: FilterValue[];
  placeholder?: string;
  defaultValueLabel?: string;
  settings?: FilterSettings;
}

export enum FiltersLayout {
  GridTwoThird = "grid-2/3",
  GridOfThree = "grid-3",
}
